import OrbitApiV1 from '.'

class VoucherAPI {
  static getVouchers(orgId) {
    return OrbitApiV1.httpGet(`/vouchers/getByOrgId/${orgId}`)
  }
}

export default VoucherAPI
